import { render, staticRenderFns } from "./ServiceDisplay.vue?vue&type=template&id=490e8b4c&scoped=true"
import script from "./ServiceDisplay.vue?vue&type=script&lang=js"
export * from "./ServiceDisplay.vue?vue&type=script&lang=js"
import style0 from "./ServiceDisplay.vue?vue&type=style&index=0&id=490e8b4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490e8b4c",
  null
  
)

export default component.exports